module.exports = __webpack_public_path__ + "static/media/lorna.215a6191.png";